import React, { Fragment } from 'react';
import Button from 'elements/Buttons/Button';

/* eslint-disable react/prop-types */
export const DefaultButton = ({ icon, right, classes, __layout = 'primary' }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <Button icon={icon} right={right} classes={classes}>{__layout}</Button>
    </div>
    <div>
      <Button disabled icon={icon} right={right} classes={classes}>{__layout}</Button>
    </div>
  </Fragment>
);

export const SecondaryButton = ({ icon, right, classes }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <Button icon={icon} right={right} classes={'secondary ' + classes}>secondary</Button>
    </div>
    <div>
      <Button disabled icon={icon} right={right} classes={'secondary ' + classes}>secondary</Button>
    </div>
  </Fragment>
);

export const ExceptionCancelButton = () => (
  <Fragment>
    <Button>Default</Button>
  </Fragment>
);
/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/constants/buttonsLayouts.js